import React from "react";
import PropTypes from "prop-types";
import { Card, Table } from "antd";
import { toDateString } from "../../../helpers/converters";
import { uniqBy } from "lodash";

const toOppositionDocs = ({ ptab, reexam, opposition_docs, opposition_app_num }) => {
  let docs = [];
  // US
  if (ptab && ptab.length > 0) {
    ptab.forEach(({ filings }) => {
      if (filings && filings.length > 0) {
        filings.forEach(obj => {
          if (obj.up_type) {
            docs.push({
              doc_id: `${ptab[0].case_number}/${obj.docket_number}`,
              date: obj.filing_date,
              document_type: obj.docket_text,
              document_url: `https://s3-us-west-1.amazonaws.com/ptab-filings/${ptab[0].case_number}/${obj.docket_number}`,
              procedure: obj.up_type
            });
          }
        });
      }
    });
  }
  if (reexam && reexam.length > 0) {
    reexam.forEach(({ transactions }) => {
      if (transactions && transactions.length > 0) {
        transactions.forEach(obj => {
          if (obj.doc_id) {
            docs.push({
              doc_id: obj.doc_id,
              date: obj.date,
              document_type: obj.text,
              document_url: `https://ped.uspto.gov/api/queries/cms/pdfDocument/${reexam[0].application_number}/${obj.doc_id}`,
              procedure: "Re-exam"
            });
          }
        });
      }
    });
  }
  // EP
  if (opposition_docs && opposition_docs.length > 0) {
    opposition_docs.forEach(obj => {
      docs.push({
        doc_id: obj.document_id,
        date: obj.date,
        document_type: obj.document_type,
        document_url: `https://register.epo.org/application?documentId=${obj.document_id}&number=${opposition_app_num}&lng=en&npl=false`,
        procedure: obj.procedure
      });
    });
  }
  return uniqBy(docs, "doc_id").sort((a, b) => new Date(b.date) - new Date(a.date));
};

const renderHyperLink = (text, record) => (record.document_url ? <a href={record.document_url}>{text}</a> : text);

const OppositionDocs = ({ data }) => {
  const columns = [
    {
      dataIndex: "date",
      title: "Date",
      width: 150,
      render: toDateString
    },
    {
      dataIndex: "document_type",
      title: "Document name",
      render: renderHyperLink
    },
    {
      dataIndex: "procedure",
      title: "Type"
    }
  ];
  return (
    <Card title="Opposition Documents" style={{ marginTop: 16 }} bodyStyle={{ padding: 0 }}>
      <Table columns={columns} dataSource={toOppositionDocs(data)} rowKey="doc_id" scroll={{ x: 1400 }} />
    </Card>
  );
};

OppositionDocs.propTypes = {
  data: PropTypes.object
};

export default OppositionDocs;
